import { LIST_DATASETS } from 'automation-ui-enrollment/queries/DatasetQueries';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import { useQuery } from 'data-fetching-client';
import TriggerGroupContainer from 'automation-ui-enrollment/components/common/TriggerGroupContainer';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import { jsx as _jsx } from "react/jsx-runtime";
export const DatasetEnrollmentCardContent = ({
  datasetId,
  objectTypeId
}) => {
  var _data$listDatasets$fi;
  const {
    data,
    loading
  } = useQuery(LIST_DATASETS);
  return /*#__PURE__*/_jsx(TriggerGroupContainer, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-enrollment.redesign.scheduledTriggers.details.groupHeading"
    }),
    children: loading ? /*#__PURE__*/_jsx(SkeletonText, {}) : /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "enrollment.canvas.datasetEnrollmentCriteria_cob",
      objectTypeId: objectTypeId,
      options: {
        datasetName: /*#__PURE__*/_jsx("b", {
          children: data === null || data === void 0 || (_data$listDatasets$fi = data.listDatasets.find(dataset => dataset.id === datasetId)) === null || _data$listDatasets$fi === void 0 ? void 0 : _data$listDatasets$fi.name
        })
      }
    })
  });
};
export default DatasetEnrollmentCardContent;